export const ANALYZE_AUDIO = 'ANALYZE_AUDIO';
export const ANALYZE_AUDIO_SUCCESS = 'ANALYZE_AUDIO_SUCCESS';

export const PROCESS_ITEMS = 'PROCESS_ITEMS';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_ITEMS_AAXML = 'SET_ITEMS_AAXML';
export const GO_TO_PREVIOUS_ITEM = 'GO_TO_PREVIOUS_ITEM';
export const GO_TO_NEXT_ITEM = 'GO_TO_NEXT_ITEM';
export const GO_TO_ITEM = 'GO_TO_ITEM';
export const SHOW_RESULTS = 'SHOW_RESULTS';
export const HIDE_RESULTS = 'HIDE_RESULTS';
export const SELECT_ANSWER = 'SELECT_ANSWER';
export const SELECT_TEST_ANSWER = 'SELECT_TEST_ANSWER';
export const RECOVER_SAVED_STATE = 'RECOVER_SAVED_STATE';
export const RESTART_EXERCISE = 'RESTART_EXERCISE';
export const SET_CORRECT_ANSWERS = 'SET_CORRECT_ANSWERS';
export const START_RECORDING = 'START_RECORDING';
export const STOP_RECORDING = 'STOP_RECORDING';
export const SET_AUTO_NUM = 'SET_AUTO_NUM';
export const SET_RANDOM_ITEMS = 'SET_RANDOM_ITEMS';
export const SET_RANDOM_ITEMS_ORDER = 'SET_RANDOM_ITEMS_ORDER';
export const SET_EXERCISE_READY = 'SET_EXERCISE_READY';
export const SET_ITEMS_TO_SHOW = 'SET_ITEMS_TO_SHOW';

export const SHOW_FEEDBACK = 'SHOW_FEEDBACK';
export const HIDE_FEEDBACK = 'HIDE_FEEDBACK';

export const SET_INTERACTION = 'SET_INTERACTION';
export const SET_VERSION = 'SET_VERSION';
export const SET_TEST_MODE = 'SET_TEST_MODE';
export const SET_TEST_SENT = 'SET_TEST_SENT';
export const SET_EX_CONTAINER = 'SET_EX_CONTAINER';
export const SET_ITEMS_KEYS = 'SET_ITEMS_KEYS';
export const MARK_ITEM_WITH_AUDIO = 'MARK_ITEM_WITH_AUDIO';
